module.exports = __webpack_public_path__ + "img/create_pool.7f6e2c45.svg";